import type { GroupResponsibleState } from '@/scopes/account/group-responsible/domain/types'
import { getDaysUntilDeparture as getDaysUntilDepartureFromDate, isOnHolidays } from '@/scopes/account/common/utils/bookingDates'

export const DAYS_BEFORE_BUS_ASSIGNMENT = 1
export const DAYS_BEFORE_ROOM_ASSIGNMENT = 10

export function isGroupBookingOnHolidays(state: GroupResponsibleState, now: Date = new Date()): boolean {
  return isOnHolidays(
    state.bookingData.group.startingDate,
    state.bookingData.group.endingDate,
    now,
  )
}

export function getDaysUntilDeparture(state: GroupResponsibleState, now: Date = new Date()): number | null {
  return getDaysUntilDepartureFromDate(state.bookingData.group.startingDate, now)
}

export function getEditDeadLine(state: GroupResponsibleState, locale: string, type: 'bus' | 'room', now: Date = new Date()): {
  deadLineDate: string
  daysBefore: number
  isOverDeadline: boolean
} {
  const daysBefore = type === 'bus' ? DAYS_BEFORE_BUS_ASSIGNMENT : DAYS_BEFORE_ROOM_ASSIGNMENT
  const defaultValue = {
    deadLineDate: '',
    daysBefore,
    isOverDeadline: true,
  }
  const startingDate = state.bookingData?.group?.startingDate
  if (!startingDate) {
    return defaultValue
  }

  const date = new Date(startingDate)
  if (Number.isNaN(date.getTime())) {
    return defaultValue
  }

  const limitDate = new Date(date)
  limitDate.setDate(date.getDate() - daysBefore)
  limitDate.setHours(23, 59, 59, 999)

  const deadLineDate = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(limitDate)

  const isOverDeadline = now > limitDate

  return { deadLineDate, daysBefore, isOverDeadline }
}
